<template>
  <div>
    <div class="outerfff">
      <div class="header">
        <span>{{$t('message.条件表达式')}}</span>
      </div>
      <div style="height:20px">
        <!-- <el-form ref="form" :model="form" label-width="80px">
          <el-form-item :label="$t('message.分群名称')">
            <el-input v-model="form.name" placeholder="测试字段未开放" style="width:50%" size="mini" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.选择分组')">
            <el-input v-model="form.name" placeholder="测试字段未开放" style="width:50%" size="mini" disabled></el-input>
          </el-form-item>
        </el-form> -->
      </div>
      <div style="display:flex;padding-left:10px;font-size:14px;" class="bigcontainer">
        <span>{{$t('message.条件簇')}}</span>
        <div style="flex:1">
          <div class="container multi">
            <div class="condition" @click="changemode">{{data.type==0?$t('message.且'):$t('message.或')}}</div>
            <div v-for="(item,index) in data.data" :key='index+value'>
              <test :data='item' :len='data.data.length' :index1='index' @deletedata='deletedata' :databasetype='item.id' :key="JSON.stringify(item)"></test>
            </div>
            <div>

            </div>
            <div style="margin-left:20px">
              <el-select v-model="value" :placeholder="$t('message.请选择添加的事件类型')" @visibleChange='changeindex' :popper-append-to-body='false' popper-class="setSelect">
                <el-option v-for="item in options" :key="item.value" :label="item.define"  :value="item.value">
                </el-option>
              </el-select>
              <el-button @click="addselect">{{$t('message.点击添加')}}</el-button>
              <!-- <el-input v-model="userid" style="width:100px"></el-input> -->
              <!-- <el-button @click="test" >{{$t('message.测试当前数据')}}</el-button> -->
              <!-- <span>{{ispass}}</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align:right;line-height:60px">
      <el-button @click="out">{{$t('message.退出')}}</el-button>
      <el-button @click="submit" type="primary">{{$t('message.提交')}}</el-button>

    </div>
  </div>
</template>
<script>
  import test from './test.vue'
  import { rejecthttp, changeflagCLOSED } from "@/utils/request";
  import { resetdata, expdata } from "@/utils/resetdata";
  import { PopupManager } from 'element-ui/lib/utils/popup'
  import { confirmmy } from '@/utils/minxins'
  import userTableType from '@/utils/UserTableType'

  export default {
    name: 'newcontainer',
    components: { test },
    props: ['datac', 'isInit', 'nochangeindex'],
    data() {
      return {
        data: {
          type: 0,
          data: []
        },
        options: userTableType.getData(),
        value: 1,
        selectvisible: false,
        id: '',
        userid: 0,
        ispass: '',
        form: {
          name: '',
          group: ''
        }
      }
    },
    methods: {
      changeindex(i) {
        console.log(i)
        // if (i) {
        //   PopupManager.zIndex = 6000
        // } else {
        //   PopupManager.zIndex = 2000
        // }
      },
      test() {
        rejecthttp(false, 'get', "/manage/datasource/runsource", {
          datasourceid: this.id,
          userid: this.userid
        }, this, (doc) => {
          changeflagCLOSED(doc, 0, this)
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            this.ispass = doc.data.data
            this.selectvisible = !this.selectvisible
          }
        })
      },
      vis() {
        //   this.selectvisible=!this.selectvisible
      },
      addselect() {
        console.log(this.value);
        this.data.data.push({ id: this.value, type: 0, data: [{ id: 0, rules: { act: '', opeation: '', limit: [] }, data: { type: 0, children: [] } }] })
      },
      changemode() {
        if (this.data.type == 0) {
          this.data.type = 1
        } else {
          this.data.type = 0
        }
      },
      submit() {
        console.log(this.data);
        console.log(this.isInit);
        let c=resetdata(this.data)
        console.log(c)
        if(c.flag==-1){
          // confirmmy()
          let title=''
          if(c.it[0]!==c.it[0]){
            title+='类型错误'+'数据1'+'需要数字'
          }
          if(c.it[1]!==c.it[1]){
            title+='类型错误'+'数据2'+'需要数字'
          }
          if(title.length==0){
            title='您有字段未填写请检查'
          }
          let that=this
          confirmmy(that, {
              title: title,
              iscancel:false,
              isprop:false
            })
          return
        }
        if (this.isInit) {
          var sendData = {
            appid: 188,
            clusters: resetdata(this.data),
            info: {
              //   外层且或
              act: this.data.type,
              appid: 188,
              //   计算状态
              complete: '',
              createdate: '',
              createid: '',
              //   初次传0编辑时用编辑id
              datasourceid: 0,
              //   
              editdate: '',
              //   
              name: '',
              //   运行计划，标准
              plantype: '',
              //   优先级
              priority: '',
              //   禁用启用状态
              state: ''
            }
          }
          this.$emit('datar', sendData)
        } else {
          this.datac.clusters = resetdata(this.data)
          this.$emit('datar', this.datac)
        }


      },
      deletedata(e) {
        console.log(e);
        this.data.data.splice(e, 1)
      },
      getfieldlist() {
        rejecthttp(false, 'get', "/manage/metadata/getfieldlistbyapp", {
          appid: 188,
        }, this, (doc) => {
          changeflagCLOSED(doc, 0, this)
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            window.sessionStorage.setItem('fieldlist', JSON.stringify(doc.data.data))
          }
        })
      },
      out() {
        this.$emit('out')
      }
    },
    mounted() {
      console.log(this.isInit)
      if (Object.keys(this.datac).length > 0) {
        this.data = expdata(this.datac.clusters)
      }
      if (!this.nochangeindex) {
        // var shade = document.querySelector('.shade')
        // shade.style.zIndex = '2000'
        // var center = shade.querySelector('.center')
        // center.style.zIndex = '1999'
      }
      console.log(this.datac);
      this.getfieldlist()
    },
    destroyed() {
      // PopupManager.zIndex=2000
      try {
        if (!this.nochangeindex) {
          // var shade = document.querySelector('.shade')
          // shade.style.zIndex = '5999'
          // var center = shade.querySelector('.center')
          // center.style.zIndex = '3000'
        }

      } catch (e) {

      }
    },
  }
</script>
<style scoped>
.setSelect{
  z-index: 9000;
}
  .outerfff {
    background-color: #fff;
    overflow: auto;
    width: 100%;
    font-size: 12px;
    height: 600px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    font-size: 12px;

    height: 30px;
    font-size: 18px;
    padding: 6px 20px 6px 20px;
    background-color: #FAFAFA;
  }

  .el-icon-circle-plus-outline {
    color: greenyellow;

    cursor: pointer;
  }

  .el-icon-circle-plus-outline:active {
    color: blue;
  }

  .container {
    font-size: 12px;

    margin: 10px 0 10px 15px;
    position: relative;
  }

  .header2 {
    display: flex;
    justify-content: space-between;
    height: 30px;
    font-size: 12px;

    margin: 0 0 0 30px;
    padding: 6px 20px 6px 20px;
    background-color: #FAFAFA;
  }

  .choose1 {
    /* height: 60px; */
    width: calc(100%-30px);
    /* display: flex; */
    justify-content: space-between;
    font-size: 12px;

    padding: 10px 40px 10px 15px;
    margin: 0 0 15px 30px;
    background-color: #F2FCFA;
  }

  .otherc {
    background-color: #ECF5FB;
  }

  .multi {
    border-left: 1px solid #ccc;
  }

  .multi::before {
    content: '';
    display: block;
    height: 1px;
    width: 15px;
    background-color: #ccc;
  }

  .multi::after {
    content: '';
    display: block;
    width: 15px;
    height: 1px;
    background-color: #ccc;
  }

  .last {
    margin-bottom: none;
  }

  .condition {
    position: absolute;
    padding: 3px;
    background-color: #0cc4a9;
    color: #fff;
    font-weight: 700;
    border-radius: 3px;
    top: 50%;
    cursor: pointer;
    left: 0;
    transform: translate(-50%, -50%);
  }
</style>


// WEBPACK FOOTER //
// src/pages/test/newcontainer.vue